export default "__VITE_ASSET__Bq4vB$_V__"